import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { v4 } from 'uuid';
import Form from 'react-jsonschema-form';
import Button from '../Button';
import { jsonSchema, jsonUiSchema } from './schema';

const log = (type) => console.log.bind(console, type);

function component({ mutate, createTestInput, history }) {
    const onSubmit = ({formData: {email, password}}) => {
        mutate({
            variables: { email, password, clientMutationId:v4() }
        })
        .then(({data}) => {
            if (data.login && data.login.success) {
                localStorage.setItem('token', data.login.token);
                history.push('/admin');
            }
            // else TODO show validation error `data.error`
        });
    };
    return (
        <Form schema={jsonSchema}
        uiSchema={jsonUiSchema}
        onChange={log('changed')}
        onError={log('errors')}
        onSubmit={onSubmit}>
            <Button type='submit'>Login</Button>
        </Form>
    );
}

export default graphql(gql`
    mutation login($email: String!, $password: String!, $clientMutationId: String!) {
        login(input: {where: {email: $email , password: $password}, clientMutationId: $clientMutationId}){
            clientMutationId
            success
            token
            error
        }
    }
`)(component);



/** WEBPACK FOOTER **
 ** ./src/Login/index.js
 **/